import { createContext } from "react";
import type { IAuthPageContext } from "../types";

export const AuthPageContext = createContext<IAuthPageContext>(
  {} as IAuthPageContext,
);
